import React from "react";
import { useState } from 'react'
import useFirebaseSession from "hooks/useFirebaseSession";
import { NavbarWithState } from 'components/shared/NavbarWithSearch'
import { NavbarMenuWithState } from 'components/shared/NavbarMenu'

function useToggleMenu() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { sessionInitialized } = useFirebaseSession();

  const toggleMenu = () => {
    if (!sessionInitialized) return;

    setMenuOpen(!menuOpen);
  };

  return { menuOpen, toggleMenu };
}

export function Header() {
    const { menuOpen, toggleMenu } = useToggleMenu()

    return (
      <>
        <NavbarWithState
          menuOpen={menuOpen}
          toggleMenu={toggleMenu}
        />
        <NavbarMenuWithState open={menuOpen} toggleMenu={toggleMenu} />
      </>
    );
}
